/* components/TabBar.svelte generated by Svelte v3.21.0 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	globals,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	null_to_empty,
	run_all,
	safe_not_equal,
	set_store_value,
	space,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

const { document: document_1 } = globals;
import { onDestroy } from "svelte";
import html2canvas from "html2canvas";
import Icon from "../assets/icons.svelte";
import { imgCount, sharedStates } from "./store.js";

function add_css() {
	var style = element("style");
	style.id = "svelte-vfjbfq-style";
	style.textContent = ":root{--anim:cubic-bezier(0.075, 0.82, 0.165, 1) 0.8s all}.tab-bar.svelte-vfjbfq.svelte-vfjbfq{display:flex;justify-content:center;position:fixed;padding-bottom:8px;width:100%;bottom:0;height:var(--tb-height);pointer-events:none}button.svelte-vfjbfq.svelte-vfjbfq{height:var(--tb-height);width:var(--tb-height);border-radius:50%;pointer-events:initial;background:#0006;-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px)}.btn-clear.svelte-vfjbfq.svelte-vfjbfq,.btn-save.svelte-vfjbfq.svelte-vfjbfq{position:absolute;transition:var(--anim);opacity:1}.btn-clear.isSaving.svelte-vfjbfq.svelte-vfjbfq,.btn-save.isSaving.svelte-vfjbfq.svelte-vfjbfq{pointer-events:none;opacity:0}.btn-add.svelte-vfjbfq.svelte-vfjbfq{transition:var(--anim)}.btn-add.isSaving.svelte-vfjbfq.svelte-vfjbfq{transform:rotate(135deg)}.btn-clear.svelte-vfjbfq.svelte-vfjbfq{left:10px}.btn-save.svelte-vfjbfq.svelte-vfjbfq{right:10px}.btn-switch.svelte-vfjbfq.svelte-vfjbfq{position:absolute;left:calc(50% + 40px);transform:scale(0.7)}.btn-shot.svelte-vfjbfq.svelte-vfjbfq,.btn-add.svelte-vfjbfq.svelte-vfjbfq{position:relative}.justify-center.svelte-vfjbfq.svelte-vfjbfq{justify-content:center}#download.svelte-vfjbfq.svelte-vfjbfq{display:none}.output-container.svelte-vfjbfq.svelte-vfjbfq{padding:0;margin:0;position:fixed;left:0;top:0;width:100vw;height:100%;background:transparent;z-index:-1;display:flex;flex-direction:column-reverse;align-items:center;justify-content:center;opacity:0;transition:var(--anim);backdrop-filter:blur(12px)}.output-container.svelte-vfjbfq img.svelte-vfjbfq{object-fit:contain;border-radius:15px;width:70%;position:relative;margin-top:10px;margin-bottom:25%}.output-container.svelte-vfjbfq figcaption.svelte-vfjbfq{margin-top:10%;position:relative;color:white;text-align:center}.output-container.isSaving.svelte-vfjbfq.svelte-vfjbfq{background:#222b;pointer-events:visible;opacity:1}.ios-output.svelte-vfjbfq.svelte-vfjbfq{background:rgba(34, 34, 34, 0.952) !important}.fkhidden.svelte-vfjbfq.svelte-vfjbfq{visibility:hidden}";
	append(document_1.head, style);
}

// (160:2) {:else}
function create_else_block(ctx) {
	let t;
	let if_block1_anchor;
	let current;
	let if_block0 = (/*$imgCount*/ ctx[5] <= 4 || /*isSaving*/ ctx[1]) && create_if_block_2(ctx);
	let if_block1 = /*$imgCount*/ ctx[5] >= 1 && create_if_block_1(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*$imgCount*/ ctx[5] <= 4 || /*isSaving*/ ctx[1]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*$imgCount, isSaving*/ 34) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_2(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t.parentNode, t);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*$imgCount*/ ctx[5] >= 1) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty & /*$imgCount*/ 32) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (144:2) {#if props.cam.isShooting}
function create_if_block(ctx) {
	let button0;
	let t;
	let button1;
	let current;
	let dispose;
	const icon0 = new Icon({ props: { name: "ring", stroke: "#ddd" } });

	const icon1 = new Icon({
			props: { name: "switch", stroke: "#ddd" }
		});

	return {
		c() {
			button0 = element("button");
			create_component(icon0.$$.fragment);
			t = space();
			button1 = element("button");
			create_component(icon1.$$.fragment);
			attr(button0, "class", "btn-shot svelte-vfjbfq");
			attr(button1, "class", "btn-switch svelte-vfjbfq");
		},
		m(target, anchor, remount) {
			insert(target, button0, anchor);
			mount_component(icon0, button0, null);
			insert(target, t, anchor);
			insert(target, button1, anchor);
			mount_component(icon1, button1, null);
			current = true;
			if (remount) run_all(dispose);

			dispose = [
				listen(button0, "click", /*click_handler*/ ctx[7]),
				listen(button1, "click", /*click_handler_1*/ ctx[8])
			];
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(icon0.$$.fragment, local);
			transition_in(icon1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon0.$$.fragment, local);
			transition_out(icon1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button0);
			destroy_component(icon0);
			if (detaching) detach(t);
			if (detaching) detach(button1);
			destroy_component(icon1);
			run_all(dispose);
		}
	};
}

// (161:4) {#if $imgCount <= 4 || isSaving}
function create_if_block_2(ctx) {
	let button;
	let current;
	let dispose;
	const icon = new Icon({ props: { name: "plus", stroke: "#ddd" } });

	return {
		c() {
			button = element("button");
			create_component(icon.$$.fragment);
			attr(button, "class", "btn-add svelte-vfjbfq");
			toggle_class(button, "isSaving", /*isSaving*/ ctx[1]);
		},
		m(target, anchor, remount) {
			insert(target, button, anchor);
			mount_component(icon, button, null);
			current = true;
			if (remount) dispose();
			dispose = listen(button, "click", /*click_handler_2*/ ctx[9]);
		},
		p(ctx, dirty) {
			if (dirty & /*isSaving*/ 2) {
				toggle_class(button, "isSaving", /*isSaving*/ ctx[1]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			destroy_component(icon);
			dispose();
		}
	};
}

// (183:4) {#if $imgCount >= 1}
function create_if_block_1(ctx) {
	let button0;
	let t;
	let button1;
	let current;
	let dispose;
	const icon0 = new Icon({ props: { name: "trash", stroke: "#ddd" } });
	const icon1 = new Icon({ props: { name: "save", stroke: "#ddd" } });

	return {
		c() {
			button0 = element("button");
			create_component(icon0.$$.fragment);
			t = space();
			button1 = element("button");
			create_component(icon1.$$.fragment);
			attr(button0, "class", "btn-clear svelte-vfjbfq");
			toggle_class(button0, "isSaving", /*isSaving*/ ctx[1]);
			toggle_class(button0, "fkhidden", /*$sharedStates*/ ctx[6].ifHideTab);
			attr(button1, "class", "btn-save svelte-vfjbfq");
			toggle_class(button1, "isSaving", /*isSaving*/ ctx[1]);
			toggle_class(button1, "fkhidden", /*$sharedStates*/ ctx[6].ifHideTab);
		},
		m(target, anchor, remount) {
			insert(target, button0, anchor);
			mount_component(icon0, button0, null);
			insert(target, t, anchor);
			insert(target, button1, anchor);
			mount_component(icon1, button1, null);
			current = true;
			if (remount) run_all(dispose);

			dispose = [
				listen(button0, "click", /*click_handler_3*/ ctx[10]),
				listen(button1, "click", /*click_handler_4*/ ctx[11])
			];
		},
		p(ctx, dirty) {
			if (dirty & /*isSaving*/ 2) {
				toggle_class(button0, "isSaving", /*isSaving*/ ctx[1]);
			}

			if (dirty & /*$sharedStates*/ 64) {
				toggle_class(button0, "fkhidden", /*$sharedStates*/ ctx[6].ifHideTab);
			}

			if (dirty & /*isSaving*/ 2) {
				toggle_class(button1, "isSaving", /*isSaving*/ ctx[1]);
			}

			if (dirty & /*$sharedStates*/ 64) {
				toggle_class(button1, "fkhidden", /*$sharedStates*/ ctx[6].ifHideTab);
			}
		},
		i(local) {
			if (current) return;
			transition_in(icon0.$$.fragment, local);
			transition_in(icon1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon0.$$.fragment, local);
			transition_out(icon1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button0);
			destroy_component(icon0);
			if (detaching) detach(t);
			if (detaching) detach(button1);
			destroy_component(icon1);
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let current_block_type_index;
	let if_block;
	let t0;
	let a;
	let t2;
	let figure;
	let img;
	let img_src_value;
	let t3;
	let figcaption;
	let div_class_value;
	let current;
	let dispose;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*props*/ ctx[0].cam.isShooting) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			div = element("div");
			if_block.c();
			t0 = space();
			a = element("a");
			a.textContent = "download";
			t2 = space();
			figure = element("figure");
			img = element("img");
			t3 = space();
			figcaption = element("figcaption");

			figcaption.innerHTML = `
      长按图片保存
      <br class="svelte-vfjbfq">
      Long press photo to save.
    `;

			attr(a, "href", "/");
			attr(a, "id", "download");
			attr(a, "download", "STKM.jpeg");
			attr(a, "class", "svelte-vfjbfq");
			if (img.src !== (img_src_value = "")) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "class", "svelte-vfjbfq");
			attr(figcaption, "class", "svelte-vfjbfq");
			attr(figure, "class", "output-container svelte-vfjbfq");
			toggle_class(figure, "isSaving", /*isSaving*/ ctx[1]);
			toggle_class(figure, "ios-output", /*$sharedStates*/ ctx[6].ifiOS);
			attr(div, "class", div_class_value = "" + (null_to_empty("tab-bar " + (/*props*/ ctx[0].cam.isShooting ? "justify-center" : "")) + " svelte-vfjbfq"));
		},
		m(target, anchor, remount) {
			insert(target, div, anchor);
			if_blocks[current_block_type_index].m(div, null);
			append(div, t0);
			append(div, a);
			/*a_binding*/ ctx[12](a);
			append(div, t2);
			append(div, figure);
			append(figure, img);
			/*img_binding*/ ctx[13](img);
			append(figure, t3);
			append(figure, figcaption);
			current = true;
			if (remount) dispose();
			dispose = listen(div, "click", click_handler_5);
		},
		p(ctx, [dirty]) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				}

				transition_in(if_block, 1);
				if_block.m(div, t0);
			}

			if (dirty & /*isSaving*/ 2) {
				toggle_class(figure, "isSaving", /*isSaving*/ ctx[1]);
			}

			if (dirty & /*$sharedStates*/ 64) {
				toggle_class(figure, "ios-output", /*$sharedStates*/ ctx[6].ifiOS);
			}

			if (!current || dirty & /*props*/ 1 && div_class_value !== (div_class_value = "" + (null_to_empty("tab-bar " + (/*props*/ ctx[0].cam.isShooting ? "justify-center" : "")) + " svelte-vfjbfq"))) {
				attr(div, "class", div_class_value);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if_blocks[current_block_type_index].d();
			/*a_binding*/ ctx[12](null);
			/*img_binding*/ ctx[13](null);
			dispose();
		}
	};
}

const click_handler_5 = evt => {
	evt.preventDefault();
};

function instance($$self, $$props, $$invalidate) {
	let $imgCount;
	let $sharedStates;
	component_subscribe($$self, imgCount, $$value => $$invalidate(5, $imgCount = $$value));
	component_subscribe($$self, sharedStates, $$value => $$invalidate(6, $sharedStates = $$value));
	let { props } = $$props;
	let isSaving = false;
	let downloadLink;
	let outputImg;
	const tmpcanva = document.createElement("canvas");

	onDestroy(() => {
		tmpcanva.remove();
	});

	const click_handler = () => {
		props.currentShot();
		$$invalidate(0, props.cam.isShooting = false, props);
	};

	const click_handler_1 = () => {
		props.cam.switchCam();
	};

	const click_handler_2 = () => {
		if (isSaving) {
			$$invalidate(1, isSaving = false);
			return;
		}

		set_store_value(sharedStates, $sharedStates.ifHideTab = false, $sharedStates);
		props.addItem();
		$$invalidate(0, props.cam.isShooting = true, props);

		setTimeout(
			() => {
				window.scrollTo({
					top: document.body.scrollHeight,
					behavior: "smooth"
				});
			},
			0
		);
	};

	const click_handler_3 = () => {
		document.location.reload();
	};

	const click_handler_4 = () => {
		set_store_value(sharedStates, $sharedStates.ifHideItemUI = true, $sharedStates);

		setTimeout(() => {
			html2canvas(document.querySelector(".photo-frame")).then(canvas => {
				$$invalidate(1, isSaving = true);
				$$invalidate(4, tmpcanva.width = canvas.width - 3, tmpcanva);
				$$invalidate(4, tmpcanva.height = canvas.height - 3, tmpcanva);
				const ctx = tmpcanva.getContext("2d");
				ctx.drawImage(canvas, 0, 0);
				const img = tmpcanva.toDataURL("image/jpeg", 1);
				$$invalidate(3, outputImg.src = img, outputImg);
				$$invalidate(3, outputImg.style.display = "flex", outputImg);
			});
		});
	};

	function a_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(2, downloadLink = $$value);
		});
	}

	function img_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			$$invalidate(3, outputImg = $$value);
		});
	}

	$$self.$set = $$props => {
		if ("props" in $$props) $$invalidate(0, props = $$props.props);
	};

	return [
		props,
		isSaving,
		downloadLink,
		outputImg,
		tmpcanva,
		$imgCount,
		$sharedStates,
		click_handler,
		click_handler_1,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		a_binding,
		img_binding
	];
}

class TabBar extends SvelteComponent {
	constructor(options) {
		super();
		if (!document_1.getElementById("svelte-vfjbfq-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { props: 0 });
	}
}

export default TabBar;